import { createContext, useContext } from "react";
import { VISITOR, type Standing } from "@/lib/standing";

/** Where the person stands, given by MemberStanding or VisitorStanding (./standing). */
export const StandingContext = createContext<Standing>(VISITOR);

/** Where the person stands, from anywhere under the site's frame. */
export function useStanding(): Standing {
    return useContext(StandingContext);
}
